import React, { FC } from "react";

import { Button, EmptyImg, Icon } from "../../common";

type Props = {
  onInviteNew: () => void;
  dataTest?: string;
};

export const ContactListEmptyState: FC<Props> = ({ onInviteNew, dataTest }) => {
  return (
    <div
      className="bg-slate-100 rounded-2xl p-6 md:px-12 md:py-16 flex flex-col items-center justify-center"
      data-test={dataTest}
    >
      <div className="max-w-[400px] text-center flex flex-col items-start md:items-center">
        <EmptyImg data-test={`${dataTest}-image`} />

        <div className="text-base text-gray-500 mb-4 mt-6 md:mt-9">
          No contacts yet
        </div>

        <div className="text-base text-gray-300 mb-8 md:mb-4 text-left md:text-center">
          You can add your first contact here or when working on your first
          invoice
        </div>

        <Button
          dataTest={`${dataTest}-action`}
          onClick={onInviteNew}
          variant={Button.variant.SECONDARY}
        >
          <span className="flex flex-row gap-x-2">
            Invite new contact{" "}
            <Icon icon="Add" size={24} className="text-gray-500" disableFill />
          </span>
        </Button>
      </div>
    </div>
  );
};
